import SafeAreaView from "../components/SafeAreaView";
import {
  View,
  Text,
  TextInput,
  StyleSheet,
  Pressable,
  useWindowDimensions,
} from "react-native";
import { TabView, TabBar } from "react-native-tab-view";
import { TabActions } from "@react-navigation/native";
import CustomButton from "../components/CustomButton";
import SimplePress from "../components/SimplePress";
import { useEffect, useContext, useRef, useState, useCallback } from "react";
import { RequestFormContext } from "../context/RequestFormContext";
import { ScrollView } from "react-native-gesture-handler";
import { ChangeType, generateGUID } from "../context/helper";
import { MaterialIcons } from "../components/VectorIcons";
import CustomSwitch from "../components/CustomSwitch";
import { lightColorDefs } from "../config";

const RequestInput = (props) => {
  return (
    <View style={styles.inputMain}>
      <View style={styles.inputContainer}>
        <TextInput
          style={styles.inputField}
          onChangeText={props.onChangeText}
          value={props.value??""}
          autoFocus={props.autoFocus}
          blurOnSubmit={props.onSubmitEditing ? false : true}
          onSubmitEditing={props.onSubmitEditing}
          ref={props.inputRef}
        />
      </View>
      <View style={styles.inputDescriptionContainer}>
        <Text style={styles.inputDescription}>{props.title}</Text>
      </View>
    </View>
  );
};

const DisabledStyle = (enabled) => {
  if (enabled)
    return {};
  else 
    return {color: "#ccc"};
}

const ControlButton = ({children, enabled = true, onPress, icon, iconpos = "right", size = 20, style}) => {
  const iconMargin = () => {
    if (children) 
      return 5;
    return 0;
  }

  return (
    <SimplePress disabled={!enabled} onPress={onPress}>
      <View style={[styles.sendButton,style]}>
        {iconpos=="left" &&
        <MaterialIcons style={{marginRight: iconMargin()}} name={icon} size={size} color={enabled?"black":"#ccc"} />
        }
        <Text style={DisabledStyle(enabled)}>
          {children}
          </Text>
        {iconpos=="right" &&
        <MaterialIcons style={{marginLeft: iconMargin()}} name={icon} size={20} color={enabled?"black":"#ccc"} />
        }
      </View>
    </SimplePress>
  );
}

const Spacer = () => {
  return <View style={{paddingBottom: 10}}></View>;
}

export const RequestFirmScreen = ({ navigation }) => {
  const { setFirmendaten, requestForm } = useContext(RequestFormContext);

  const ref_input2 = useRef();
  const ref_input3 = useRef();
  const ref_input4 = useRef();
  const ref_input5 = useRef();
  const ref_input6 = useRef();

  const [fieldFirma, setFieldFirma] = useState("");
  const [fieldAnsprechpartner, setFieldAnsprechpartner] = useState("");
  const [fieldTelefon, setFieldTelefon] = useState("");
  const [fieldEMail, setFieldEMail] = useState("");
  const [fieldStrasse, setFieldStrasse] = useState("");
  const [fieldOrt, setFieldOrt] = useState("");

  const isFilled = () => {
    return (
      fieldFirma.length > 0 &&
      fieldTelefon.length > 0 &&
      fieldEMail.length > 0 &&
      fieldStrasse.length > 0 &&
      fieldOrt.length > 0
    );
  };
  const submitForm = () => {
    if (isFilled()) {
      const firmdata = {
        firma: fieldFirma,
        ansprechpartner: fieldAnsprechpartner,
        telefon: fieldTelefon,
        email: fieldEMail,
        strasse: fieldStrasse,
        ort: fieldOrt,
      };

      setFirmendaten(firmdata);

      navigation.navigate("RequestBranch");
    }
  };
  const schemeStyle = StyleSheet.create(lightColorDefs);

  useEffect(() => {
    if (requestForm.current.Firmendaten.firma)
      setFieldFirma(requestForm.current.Firmendaten.firma);
    if (requestForm.current.Firmendaten.ansprechpartner)
      setFieldAnsprechpartner(requestForm.current.Firmendaten.ansprechpartner);
    if (requestForm.current.Firmendaten.telefon)
      setFieldTelefon(requestForm.current.Firmendaten.telefon);
    if (requestForm.current.Firmendaten.email)
      setFieldEMail(requestForm.current.Firmendaten.email);
    if (requestForm.current.Firmendaten.strasse)
      setFieldStrasse(requestForm.current.Firmendaten.strasse);
    if (requestForm.current.Firmendaten.ort)
      setFieldOrt(requestForm.current.Firmendaten.ort);
  }, []);

  return (
    <SafeAreaView style={styles.mainContainer}>
      <View style={styles.headerContainer}>
        <Text style={styles.headerText}>Firmendaten / Rechnungsanschrift</Text>
      </View>
      <View style={{flex: 1}} >
        <RequestInput
          title={"Firmenname"}
          value={fieldFirma}
          onChangeText={(text) => {
            setFieldFirma(text);
          }}
          autoFocus={true}
          onSubmitEditing={() => ref_input2.current.focus()}
          />
        <RequestInput
          title={"Ansprechpartner"}
          value={fieldAnsprechpartner}
          onChangeText={(text) => {
            setFieldAnsprechpartner(text);
          }}
          inputRef={ref_input2}
          onSubmitEditing={() => ref_input3.current.focus()}
          />
        <RequestInput
          title={"Telefonnummer"}
          value={fieldTelefon}
          onChangeText={(text) => {
            setFieldTelefon(text);
          }}
          inputRef={ref_input3}
          onSubmitEditing={() => ref_input4.current.focus()}
          />
        <RequestInput
          title={"E-Mail-Adresse"}
          value={fieldEMail}
          onChangeText={(text) => {
            setFieldEMail(text);
          }}
          inputRef={ref_input4}
          onSubmitEditing={() => ref_input5.current.focus()}
          />
        <RequestInput
          title={"Straße"}
          value={fieldStrasse}
          onChangeText={(text) => {
            setFieldStrasse(text);
          }}
          inputRef={ref_input5}
          onSubmitEditing={() => ref_input6.current.focus()}
          />
        <RequestInput
          title={"PLZ/Ort"}
          value={fieldOrt}
          onChangeText={(text) => {
            setFieldOrt(text);
          }}
          inputRef={ref_input6}
          onSubmitEditing={() => submitForm()}
          />
      </View>
      <View style={{ flexDirection: "row", justifyContent: "flex-end" }}>
        <ControlButton enabled={isFilled()} onPress={() => {submitForm();}} icon={"arrow-forward-ios"} >
          Standorte
        </ControlButton>
      </View>

      <View style={styles.infoContainer}>
        <Text style={styles.infoText}>
        </Text>
      </View>
    </SafeAreaView>
  );
};

const RequestMesstelle = (props) => {
  const [fieldBezeichnung, setFieldBezeichnung] = useState("");
  const [fieldMin, setFieldMin] = useState(null);
  const [fieldMax, setFieldMax] = useState(null);
  const [fieldID, setFieldID] = useState("");

  const ref_input2 = useRef();
  const ref_input3 = useRef();

  const changeBezeichnungText = (text) => {
    props.onChange(props.data.branchid, props.data.intid, ChangeType.textMessstelle, text);
    setFieldBezeichnung(text);
  };

  const changeMinText = (text) => {
    props.onChange(props.data.branchid, props.data.intid, ChangeType.textMessstelleMin, text);
    setFieldMin(text);
  };

  const changeMaxText = (text) => {
    props.onChange(props.data.branchid, props.data.intid, ChangeType.textMessstelleMax, text);
    setFieldMax(text);
  };

  useEffect(() => {
    setFieldBezeichnung(props.data.bezeichnung);
    setFieldMin(props.data.min);
    setFieldMax(props.data.max);
    setFieldID(props.data.intid);

    //console.log(props.data.intid);
  }, []);

  return (
    <>
      {!props.data.isnew && (
        <View>
          <Text>Test</Text>
          <Text>{props.data.bezeichnung}</Text>
          <Text>{props.data.min}</Text>
          <Text>{props.data.max}</Text>
        </View>
      )}
      {props.data.isnew && (
        <View style={{flexDirection: "row"}}>
          <View style={{width: 400}}>
            <RequestInput
              title={"Bezeichung"}
              value={fieldBezeichnung}
              onChangeText={(text) => {
                changeBezeichnungText(text);
              }}
              onSubmitEditing={() => ref_input2.current.focus()}
              />
            </View>
          <View style={{width: 100}}>
            <RequestInput
              title={"Minimum"}
              value={fieldMin}
              onChangeText={(text) => {
                changeMinText(text);
              }}
              inputRef={ref_input2}
              onSubmitEditing={() => ref_input3.current.focus()}
              />
          </View>
          <View style={{width: 100}}>
            <RequestInput
              title={"Maximum"}
              value={fieldMax}
              onChangeText={(text) => {
                changeMaxText(text);
              }}
              inputRef={ref_input3}
              />          
          </View>
          {props.canDelete &&
          <View><SimplePress onPress={() => {
            //console.log(props.data.intid+": "+fieldBezeichnung);
            props.onChange(props.data.branchid, props.data.intid, ChangeType.delMessstelle, null);
          }}><Text>löschen</Text></SimplePress></View>
        }
        </View>
      )}
    </>
  );

}

const RequestMesstellen = (props) => {
  return (
    <View>
      {props.data.map((item) => <RequestMesstelle key={item.intid} data={item} canDelete={props.data.length>1} onChange={props.onChange} />)}
    </View>
  );
}

const RequestBenutzer = (props) => {
  const [fieldName, setFieldName] = useState("");
  const [fieldID, setFieldID] = useState("");

  const changeNameText = (text) => {
    props.onChange(props.data.branchid, props.data.intid, ChangeType.textBenutzer, text);
    setFieldName(text);
  };

  useEffect(() => {
    setFieldName(props.data.name);
    setFieldID(props.data.intid);

    //console.log(props.data.intid);
  }, []);

  return (
    <>
      {!props.data.isnew && (
        <View>
          <Text>Test</Text>
          <Text>{props.data.name}</Text>
        </View>
      )}
      {props.data.isnew && (
        <View style={{flexDirection: "row"}}>
          <View style={{width: 400}}>
            <RequestInput
              title={"Name"}
              value={fieldName}
              onChangeText={(text) => {
                changeNameText(text);
              }}
            />
          </View>
          {props.canDelete &&
          <View><SimplePress onPress={() => {
            //console.log(props.data.intid+": "+fieldBezeichnung);
            props.onChange(props.data.branchid, props.data.intid, ChangeType.delBenuter, null);
          }}><Text>löschen</Text></SimplePress></View>
        }
        </View>
      )}
    </>
  );

}

const RequestBenutzerList = (props) => {
  return (
    <View>
      {props.data.map((item) => <RequestBenutzer key={item.intid} data={item} canDelete={props.data.length>1} onChange={props.onChange} />)}
    </View>
  );
}

const RequestBranch = (props) => {
  const [fieldStandort, setFieldStandort] = useState("");
  const [fieldTelefon, setFieldTelefon] = useState("");
  const [fieldStrasse, setFieldStrasse] = useState("");
  const [fieldOrt, setFieldOrt] = useState("");
  const [fieldEMail, setFieldEMail] = useState("");

  const [messstellen, setMessstellen] = useState([]);
  const [benutzer, setBenutzer] = useState([]);

  const ref_input2 = useRef();
  const ref_input3 = useRef();
  const ref_input4 = useRef();
  const ref_input5 = useRef();

  const changeStandortText = (text) => {
    setFieldStandort(text);
    props.onChange(props.data.intid, 0, ChangeType.textStandort, text);
  };
  const changeTelefonText = (text) => {
    setFieldTelefon(text);
    props.onChange(props.data.intid, 0, ChangeType.textTelefon, text);
  };
  const changeStrasseText = (text) => {
    setFieldStrasse(text);
    props.onChange(props.data.intid, 0, ChangeType.textStrasse, text);
  };
  const changeOrtText = (text) => {
    setFieldOrt(text);
    props.onChange(props.data.intid, 0, ChangeType.textOrt, text);
  };
  const changeEMailText = (text) => {
    setFieldEMail(text);
    props.onChange(props.data.intid, 0, ChangeType.textEMail, text);
  };
  const changeMessstelle = (branch_intid, point_intid, changeType, value) => {
    let id = props.onChange(branch_intid, point_intid, changeType, value);

    if (changeType==ChangeType.delMessstelle) {
      let mstellen = messstellen.filter(item => item.intid!=point_intid);
      setMessstellen(mstellen);
    }

    return id;
  }
  const changeBenutzer = (branch_intid, user_intid, changeType, value) => {
    let id = props.onChange(branch_intid, user_intid, changeType, value);

    if (changeType==ChangeType.delBenuter) {
      let usr = benutzer.filter(item => item.intid!=user_intid);
      setBenutzer(usr);
    }

    return id;
  }

  useEffect(() => {
    setFieldStandort(props.data.standort);
    setFieldTelefon(props.data.telefon);
    setFieldStrasse(props.data.strasse);
    setFieldOrt(props.data.ort);
    setFieldEMail(props.data.email);
    setMessstellen([...props.data.messstellen]);
    setBenutzer([...props.data.benutzer]);
  }, []);

  return (
    <>
      {!props.data.isnew && (
        <View>
          <Text>Test</Text>
          <Text>{props.data.telefon}</Text>
          <Text>{props.data.strasse}</Text>
          <Text>{props.data.ort}</Text>
          <Text>{props.data.email}</Text>
        </View>
      )}
      {props.data.isnew && (
        <ScrollView style={styles.formContainer}>
          <RequestInput
            title={"Standort"}
            value={fieldStandort}
            onChangeText={(text) => {
              changeStandortText(text);
            }}
            onSubmitEditing={() => ref_input2.current.focus()}
          />
          <RequestInput
            title={"Telefon"}
            value={fieldTelefon}
            onChangeText={(text) => {
              changeTelefonText(text);
            }}
            inputRef={ref_input2}
            onSubmitEditing={() => ref_input3.current.focus()}
          />
          <RequestInput
            title={"Strasse"}
            value={fieldStrasse}
            onChangeText={(text) => {
              changeStrasseText(text);
            }}
            inputRef={ref_input3}
            onSubmitEditing={() => ref_input4.current.focus()}
          />
          <RequestInput
            title={"Ort"}
            value={fieldOrt}
            onChangeText={(text) => {
              changeOrtText(text);
            }}
            inputRef={ref_input4}
            onSubmitEditing={() => ref_input5.current.focus()}
          />
          <RequestInput
            title={"E-Mail-Adressen"}
            value={fieldEMail}
            onChangeText={(text) => {
              changeEMailText(text);
            }}
            inputRef={ref_input5}
          />
        <View style={styles.infoContainer}>
          <Text style={styles.infoText}>
            * An diese E-Mail-Adressen werden sämtliche Sensormeldungen aller
            Sensoren des Standortes gesendet. Bitte beachten Sie, dass eine
            Meldung an private E-Mail Adressen evtl. nicht DSGVO konform ist und
            wir empfehlen hier Kundenseitige Einrichtung oder Nutzung allgemeiner
            Firmen Adressen, wie z.B. manager@muster-firma.de
          </Text>
        </View>

          <View>
            <View>
              <View style={styles.headerContainer}>
                <Text style={styles.subHeaderText}>Messstellen</Text>
                <ControlButton 
                  icon={"add"} 
                  size={30} 
                  style={{margin: 0, marginLeft: 10 , padding: 5}} 
                  onPress={() => {
                    let mstellen = [...messstellen];
  
                    let msid = changeMessstelle(props.data.intid,0,ChangeType.addMessstelle,null);
                    //setMessstellen(messstellen);
                    setMessstellen([...mstellen,{isnew: true, intid: msid, branchid: props.data.intid, bezeichnung: "", min: null, max: null}]);
                  }} 
                />
              </View>
              <RequestMesstellen data={messstellen} onChange={changeMessstelle} />
            </View>
          </View>
          <View>
            <View>
              <View style={styles.headerContainer}>
                <Text style={styles.subHeaderText}>Benutzer</Text>
                <ControlButton 
                  icon={"add"} 
                  size={30} 
                  style={{margin: 0, marginLeft: 10 , padding: 5}} 
                  onPress={() => {
                    let usr = [...benutzer];
  
                    let usrid = changeBenutzer(props.data.intid,0,ChangeType.addBenutzer,null);
                    setBenutzer([...usr,{isnew: true, intid: usrid, branchid: props.data.intid, name: ""}]);
                  }} 
                />
              </View>
              <RequestBenutzerList data={benutzer} onChange={changeBenutzer} />
            </View>
          </View>
          
        </ScrollView>
      )}
    </>
  );
};

const RequestBranchView = (props) => {
  const branches = props.data;
  const tabIndex = props.tabindex;

  const layout = useWindowDimensions();

  const [routes, setRoutes] = useState([]);
  const [index, setIndex] = useState(tabIndex);

  const setBranches = (br) => {
    let rts = [];
    br.forEach((element) => {
      rts.push({ key: element.intid, title: element.standort, data: element });
    });
    setRoutes(rts);
  };

  const removeBranch = (branchid) => {
    props.onChange(branchid, 0, ChangeType.delStandort, null);    
  }

  useEffect(() => {
    setBranches(branches);
    const timer = setTimeout(() => {
      setIndex(tabIndex);
    }, 0);
    return () => clearTimeout(timer);
  }, [branches, tabIndex]);

  /*   <View
  style={{
    flex: 1,
    backgroundColor: route.key == "first" ? "#ff4081" : "#673ab7",
  }}
>
  <SimplePress onPress={props.onChange}>
    <Text>{route.key}</Text>
  </SimplePress>
</View>



 */

  const renderTabBar = (props) => {

    const navigateTo = (itemkey) => {
      props.jumpTo(itemkey);
    }
    return <TabBar
      {...props}
      activeColor={"black"}
      inactiveColor={"silver"}
      scrollEnabled={true}
      indicatorStyle={{
        backgroundColor: "#478cc5",
        marginBottom: 5,
        marginHorizontal: 5,
        height: 5,
        borderRadius: 4}}
      style={{ backgroundColor: "white"}}
      renderTabBarItem={(props) => {

        const selIndex = props.navigationState.index;
        const itemKey = props.key;

        const route = props.navigationState.routes[selIndex];

        const focused = route?.key==itemKey;

        const itemWidth = props.defaultTabWidth;

        const color = focused?props.activeColor:props.inactiveColor;


        return (
          <SimplePress 
            key={itemKey}
            onPress={() => navigateTo(itemKey)}
          >
            <View style={{width: itemWidth, flexDirection: "row"}}>
              <Text style={{flex: 1, color, margin: 10, paddingVertical: 5}}>{props.route.data.standort ? props.route.data.standort : "Neuer Standort"}</Text>
              {focused && (props.navigationState.routes.length>1) &&
              <View>
                <SimplePress onPress={() => {
                  const newKey = selIndex==props.navigationState.routes.length-1?props.navigationState.routes[selIndex-1].key:props.navigationState.routes[selIndex+1].key;
                  navigateTo(newKey);
                  removeBranch(props.route.data.intid);
                }}>
                  <MaterialIcons name={"close"} size={16} color={color} />
                </SimplePress>
              </View>
              }
            </View>
          </SimplePress>
        );
      }}
    />
  };

  const renderScene = ({ route, jumpTo }) => {
    return <RequestBranch data={route.data} onChange={props.onChange} />;
  };

  return (
    <View style={{ flex: 1 }}>
      {routes.length>0&&
      <TabView
        navigationState={{ index, routes }}
        renderScene={renderScene}
        onIndexChange={setIndex}
        initialLayout={{ width: layout.width }}
        renderTabBar={renderTabBar}
      />
}
    </View>
  );
};

export const RequestBranchScreen = ({ navigation }) => {
  const { setStandortdaten, requestForm } = useContext(RequestFormContext);

  const [tabIndex, setTabIndex] = useState(0);
  const [branches, setBranches] = useState([]);

  const [formFilled, setFormFilled] = useState(false);

  const branchChange = (branch_intid, point_intid, changeType, value) => {
    let br;
    let ms;
    let brs;
    let usr;
    let idx;

    let retvalue = null;

    switch (changeType) {
      case ChangeType.addStandort:
        var bid = generateGUID(32);
        const branch = {
          isnew: true,
          intid: bid,
          standort: "",
          telefon: "",
          strasse: "",
          ort: "",
          email: "",

          messstellen : [
            {
              isnew: true,
              intid: generateGUID(32),
              branchid: bid,
              bezeichnung: "",
              min: null,
              max: null
            },
          ],

          benutzer : [
            {
              isnew: true,
              intid: generateGUID(32),
              branchid: bid,
              name: "",
            },
          ]
        
        };
        idx = branches.length;
        brs = [...branches, branch];
        setBranches(brs);
        setTabIndex(idx);

        setStandortdaten(branch);

        setFormFilled(isFilled(brs));
        //console.log(requestForm.current);
        break;
      case ChangeType.delStandort:
        br = branches.find((item) => item.intid == branch_intid);
        setStandortdaten(br,true);

        br = branches.filter((item) => item.intid != branch_intid);
        setBranches(br);

        setFormFilled(isFilled(br));
        break;
      case ChangeType.textStandort:
        br = branches.find((item) => item.intid == branch_intid);
        br.standort = value;

        setStandortdaten(br);

        setFormFilled(isFilled(branches));
        break;
      case ChangeType.textTelefon:
        br = branches.find((item) => item.intid == branch_intid);
        br.telefon = value;
        setStandortdaten(br);
        break;
      case ChangeType.textStrasse:
        br = branches.find((item) => item.intid == branch_intid);
        br.strasse = value;
        setStandortdaten(br);
        setFormFilled(isFilled(branches));
        break;
      case ChangeType.textOrt:
        br = branches.find((item) => item.intid == branch_intid);
        br.ort = value;
        setStandortdaten(br);
        setFormFilled(isFilled(branches));
        break;
      case ChangeType.textEMail:
        br = branches.find((item) => item.intid == branch_intid);
        br.email = value;
        setStandortdaten(br);
        break;
      case ChangeType.addMessstelle:
        br = branches.find((item) => item.intid == branch_intid);

        retvalue=generateGUID(32);
        br.messstellen.push(
        {
          isnew: true,
          intid: retvalue,
          branchid: br.intid,
          bezeichnung: "",
          min: null,
          max: null
        });

        setStandortdaten(br);

        //brs = [...branches];
        //setBranches(brs);

        break;
      case ChangeType.delMessstelle:
        br = branches.find((item) => item.intid == branch_intid);

        let mstellen = br.messstellen.filter(item => item.intid!=point_intid);
        br.messstellen = mstellen;

        setStandortdaten(br);
        setFormFilled(isFilled(branches));
        break;
      case ChangeType.textMessstelle:
        br = branches.find((item) => item.intid == branch_intid);
        ms = br.messstellen.find((item) => item.intid == point_intid);
        ms.bezeichnung = value;
        setStandortdaten(br);
        setFormFilled(isFilled(branches));
        break;
      case ChangeType.textMessstelleMin:
        br = branches.find((item) => item.intid == branch_intid);
        ms = br.messstellen.find((item) => item.intid == point_intid);
        if (value=="")
          value=null;
        ms.min = value;
        setStandortdaten(br);
        break;
      case ChangeType.textMessstelleMax:
        br = branches.find((item) => item.intid == branch_intid);
        ms = br.messstellen.find((item) => item.intid == point_intid);
        if (value=="")
          value=null;
        ms.max = value;
        setStandortdaten(br);


        break;
      case ChangeType.addBenutzer:
          br = branches.find((item) => item.intid == branch_intid);
  
          retvalue=generateGUID(32);
          br.benutzer.push(
          {
            isnew: true,
            intid: retvalue,
            branchid: br.intid,
            name: "",
          });
  
          setStandortdaten(br);
  
          //brs = [...branches];
          //setBranches(brs);
  
          break;
        case ChangeType.delBenuter:
          br = branches.find((item) => item.intid == branch_intid);
  
          usr = br.benutzer.filter(item => item.intid!=point_intid);
          br.benutzer = usr;
  
          setStandortdaten(br);
          break;
        case ChangeType.textBenutzer:
          br = branches.find((item) => item.intid == branch_intid);
          usr = br.benutzer.find((item) => item.intid == point_intid);
          usr.name = value;
          setStandortdaten(br);
          break;
        default:
        console.log(changeType);
        break;
    }
    return retvalue;
  };

  const isFilled = (brs) => {
    var res = true;
    brs.forEach(branch => {
      if ((!branch.standort) || (!branch.strasse) || (!branch.ort) || (branch.messstellen.length==0) || (!branch.messstellen[0].bezeichnung)) {
        res = false;
      }
    });
    return res;
  };

  useEffect(() => {
    if (requestForm.current.Standorte.length==0)
      branchChange(0, 0, ChangeType.addStandort, null);
    else
      setBranches(requestForm.current.Standorte);
  }, []);

  /* <ScrollView>
  <RequestBranchList data={branches} onChange={branchChange} />  
  </ScrollView>
  */

  return (
    <SafeAreaView style={styles.mainContainer}>
      <View style={styles.headerContainer}>
        <Text style={styles.headerText}>Standorte und Messstellen</Text>
      </View>
      <View style={{ flexDirection: "row"}}>
        <ControlButton onPress={() => {branchChange(0, 0, ChangeType.addStandort, null);}} icon="add">
          weiterer Standort
        </ControlButton>
      </View>
      <RequestBranchView
        data={branches}
        tabindex={tabIndex}
        onChange={branchChange}
      />
      <View style={{ flexDirection: "row", justifyContent: "flex-end" }}>
        <ControlButton enabled={true} onPress={() => {navigation.goBack();}} icon="arrow-back-ios" iconpos="left">
          Firmendaten
        </ControlButton>
        <View style={{flex: 1}} />
        <ControlButton enabled={formFilled} onPress={() => {navigation.navigate("RequestSummary")}} icon="arrow-forward-ios">
          Zusammenfassung
        </ControlButton>
      </View>
    </SafeAreaView>
  );
};
/*

  */
export const RequestSummaryScreen = ({ navigation }) => {
  const { requestForm, sendRequest } = useContext(RequestFormContext);

  const [resultText, setResultText] = useState(null);
  const [confirmEMail, setConfirmEMail] = useState(false);
  const [confirmWLAN, setConfirmWLAN] = useState(false);


  const schemeStyle = StyleSheet.create(lightColorDefs);

  const TextList = (props) => {
    return (
      <View style={[{flexDirection: "row"},props.style]}>
        {props.values.map((item,index) => {
          var style = {};
          if ((props.styles!=undefined) && (props.styles.length>=index-1))
            style = props.styles[index];

          return (
            <Text key={index} style={style}>{item}</Text>
          );
        })}
      </View>
    );
  }

  return (
    <SafeAreaView style={styles.mainContainer}>
      <View style={styles.headerContainer}>
        <Text style={styles.headerText}>Zusammenfassung</Text>
      </View>
      <ScrollView style={styles.summarySectionContainer}>
        <View style={styles.summarySubSectionContainer}>
          <TextList values={["Firmendaten"]} styles={[styles.summarySubHeaderText]}/>
          <TextList values={[requestForm.current.Firmendaten.firma]}/>
          <TextList values={[requestForm.current.Firmendaten.strasse]}/>
          <TextList values={[requestForm.current.Firmendaten.ort]}/>
          <Spacer />
          <TextList values={["Ansprechpartner:",requestForm.current.Firmendaten.ansprechpartner]} styles={[{width: 135, fontWeight: "bold"}]}/>
          <TextList values={["Telefon:",requestForm.current.Firmendaten.telefon]} styles={[{width: 135, fontWeight: "bold"}]}/>
          <TextList values={["E-Mail:",requestForm.current.Firmendaten.email]} styles={[{width: 135, fontWeight: "bold"}]}/>
        </View>
        <View style={styles.summarySubSectionContainer}>
          <TextList values={["Standorte"]} styles={[styles.summarySubHeaderText]}/>
          <View>
            {requestForm.current.Standorte.map((item) => {
              var emails = item.email.split(/(?:;|,| )+/);
              

              return (
              <View key={item.intid} style={styles.summaryBranchContainer}>
                <View style={styles.summarySubSectionContainer}>
                  <TextList values={[item.standort]}/>
                  <TextList values={[item.strasse]}/>
                  <TextList values={[item.ort]}/>
                  <Spacer />
                  <TextList values={["Telefon:",item.telefon]} styles={[{width: 135, fontWeight: "bold"}]}/>
                  <TextList values={["E-Mails:",emails.join("\r\n")]} styles={[{width: 135, fontWeight: "bold"}]}/>
                </View>

                <View style={[styles.summarySubSectionContainer,{maxWidth: 420}]}>
                  <TextList values={["Messstellen"]} styles={[styles.summarySubSubHeaderText]}/>
                  <TextList 
                    style={{borderBottomWidth: 1, borderBottomColor: "black"}}
                    values={[
                      "#",
                      "Bezeichnung",
                      "Minimum",
                      "Maximum"
                    ]} 
                    styles={[
                      {width: 30, fontStyle: "italic"},
                      {width: 250, fontStyle: "italic"},
                      {width: 80, fontStyle: "italic"},
                      {width: 80, fontStyle: "italic"}
                    ]}
                  />
                  {item.messstellen.map((mitem,index) => { 
                    return (
                      <TextList 
                        key={mitem.intid}
                        values={[
                          index+1,
                          mitem.bezeichnung,
                          mitem.min,
                          mitem.max
                        ]} 
                        styles={[
                          {width: 30},
                          {width: 250},
                          {width: 80},
                          {width: 80}
                        ]}
                      />
                    )
                  })}
                </View>

                <View style={styles.summarySubSectionContainer}>
                  <Text style={styles.summarySubSubHeaderText}>Benutzer</Text>
                  {item.benutzer.map((bitem) => {
                    return (<View key={bitem.intid}>
                      <Text>{bitem.name}</Text>
                    </View>)
                  })}
                </View>
              </View>)
            })}
          </View>
        </View>

      </ScrollView>
      <View style={styles.switchContainer}>
        <View style={{flex:1}} />
        <View>
          <View style={{flexDirection: "row", marginTop:10, alignItems: "center"}}>
            <View style={{marginRight: 10}}>
              <CustomSwitch
                onColor={schemeStyle.switchColors.blueOnColor}
                offColor={schemeStyle.switchColors.blueOffColor}
                disabledColor={schemeStyle.switchColors.disabledColor}
                circleActiveColor={schemeStyle.switchColors.circleActiveColor}
                circleInActiveColor={schemeStyle.switchColors.circleInActiveColor}
                value={confirmWLAN}
                onValueChange={(val) => {setConfirmWLAN(val);}}
                disabled={false}
                />
            </View>
            <Text style={{maxWidth: 300, fontSize: 12}}>an den Messstellen ist ein WLAN-Signal mit 2,4 GHz in ausreichender Stärke vorhanden (Pflicht)</Text>
          </View>
          <View style={{flexDirection: "row", marginTop:10}}>
            <View style={{marginRight: 10}}>
              <CustomSwitch
                onColor={schemeStyle.switchColors.blueOnColor}
                offColor={schemeStyle.switchColors.blueOffColor}
                disabledColor={schemeStyle.switchColors.disabledColor}
                circleActiveColor={schemeStyle.switchColors.circleActiveColor}
                circleInActiveColor={schemeStyle.switchColors.circleInActiveColor}
                value={confirmEMail}
                onValueChange={(val) => {setConfirmEMail(val);}}
                disabled={false}
                />
            </View>
            <Text>Kopie der Auftragsbestätigung per E-Mail</Text>
          </View>
        </View>
      </View>
      {resultText&&
      <View style={styles.errorContainer}>
        <Text style={styles.errorText}>{resultText}</Text>
      </View>}
      <View style={{ flexDirection: "row", justifyContent: "flex-end" }}>
        <ControlButton enabled={true} onPress={() => {navigation.goBack();}} icon="arrow-back-ios" iconpos="left">
          Standorte
        </ControlButton>
        <View style={{flex: 1}} />
        <ControlButton 
          enabled={confirmWLAN} 
          onPress={() => {
            sendRequest(confirmEMail)
            .then((msg) => {
              navigation.navigate("RequestSuccess");
            })
            .catch((e) => {
              setResultText(e.reason);
            });
          }} 
          icon="arrow-forward-ios"
        >
          Absenden
        </ControlButton>
      </View>
    </SafeAreaView>
  );
};

export const RequestSuccessScreen = ({ navigation }) => {
  return (
    <SafeAreaView style={styles.mainContainer}>
      <View style={styles.headerContainer}>
        <Text style={styles.headerText}>Antrag gesendet</Text>
      </View>
      <View style={styles.summarySectionContainer}>
        <Text>Der Antrag wurde erfolgreich an Sencono gesendet.</Text>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    paddingTop: 10,
    backgroundColor: "#fff"
  },
  headerContainer: {
    flexDirection: "row",
    marginHorizontal: 10,
    marginBottom: 20,
    alignItems: "flex-end"
  },
  headerText: {
    fontFamily: "Roboto-Bold",
    fontSize: 18,
  },
  subHeaderText: {
    fontFamily: "Roboto-Bold",
    fontSize: 16,
  },
  inputMain: {
    marginBottom: 10,
  },
  inputContainer: {
    flexDirection: "row",
    alignItems: "center",
    borderBottomColor: "#ccc",
    borderBottomWidth: 1,
    marginHorizontal: 10,
    backgroundColor: "#f0ffff",
    flex: 1,
  },
  inputField: {
    fontFamily: "Roboto-Regular",
    fontSize: 20,
    flex: 1,
    paddingHorizontal: 10,
    paddingVertical: 8,
    width: 0
  },
  inputDescriptionContainer: {
    marginHorizontal: 10,
  },
  inputDescription: {
    fontFamily: "Roboto-Regular",
    fontSize: 14,
    color: "#808080",
  },
  formContainer : {
    marginTop: 10
  },
  sendButton: {
    margin: 10,
    borderColor: "#ccc",
    borderWidth: 1,
    padding: 10,
    flexDirection: "row"
  },

  infoContainer: {
    marginHorizontal: 10,
    marginBottom: 10
  },
  infoText: {
    fontFamily: "Roboto-Regular",
    fontSize: 10,
    color: "#808080",
  },
  summarySectionContainer: {
    flex: 1,
    marginHorizontal: 10,
  },
  summarySubSectionContainer: {
    marginBottom: 10
  },
  summarySubHeaderText: {
    fontFamily: "Roboto-Bold",
    fontSize: 16,
    textDecorationLine: "underline"
  },
  summarySubSubHeaderText: {
    fontFamily: "Roboto-Bold",
    fontSize: 14,
    fontStyle: "italic",
    textDecorationLine: "underline"
  },
  summarySpacer: {
    paddingBottom: 5
  },
  summaryBranchContainer: {
    borderBottomColor: "silver",
    borderBottomWidth: 1,
    marginBottom: 10
  },
  errorContainer: {
    alignItems: "flex-end",
    margin: 10

  },
  errorText : {
    color: "darkred"
  },
  switchContainer: {
    flexDirection: "row",
    margin: 10,
    alignItems: "flex-end"
  },
});
